var React = require('react');

function IconsArrowRightLinkBlackInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#02242F","fillRule":"evenodd"},[React.createElement("path",{"d":"M3 11h17v1H3z","key":0}),React.createElement("path",{"d":"M13.793 17.157 19.45 11.5l-5.657-5.657.707-.707 6.364 6.364-6.364 6.364-.707-.707z","key":1})]));
}

IconsArrowRightLinkBlackInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconsArrowRightLinkBlackInline;

IconsArrowRightLinkBlackInline.default = IconsArrowRightLinkBlackInline;
